import React from 'react'
import Bethuadaharishowroom from "../images/Bethuadahari Showroom.jpg";
import Bethuadaharishowroombarina from "../images/Siddheswari Bastralaya - Barnia.jpeg";


function Slider2() {
  return (
    <div>
     <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={Bethuadaharishowroombarina} className="d-block w-100" alt="Bethuadaharishowroom"/>
    </div>
    <div className="carousel-item">
      <img src={Bethuadaharishowroom} className="d-block w-100" alt="Barnia Garment Showroom"/>
    </div>

  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Slider2